import { useState } from "react";
import styles from "./users.module.css";
import OrderDetails from "./OrderDetails";
import OrderInvoice from "./OrderInvoice";
import OrderStatus from "./OrderStatus";
import { useSelector } from "react-redux";
import SidebarField from "../../../components/Sidebar/SidebarField";
import ChatComponent from "../../../components/Socket/ChatUI";
import OrderApi from "../../../apis/order.apis";

const OrderModal = ({ handleCloseOrderModal, isOrderDetail, orderData,refreshOrderList }) => {
  const [toggleContent, setToggleContent] = useState("Details");
  const [isFullWidth, setIsFullWidth] = useState(false)

  

  const { theme } = useSelector((state) => state.theme);
  if (isOrderDetail) {
    return (
      <>
        <SidebarField footer={false} handleClose={() => handleCloseOrderModal()} title={`Order Details`}>
          <div style={{ display: "flex" }}>
            {["Details",
              "Status",
              "Chat"].map((item) => (
                <hr
                  style={{
                    width: "50%",
                    borderTop:
                      item === toggleContent ? "5px solid  " : "1px solid",
                    color:
                      item === toggleContent
                        ? "rgb(15 61 100 / var(--tw-text-opacity)"
                        : "var(--light-color3)",
                    borderRadius: "10px",
                    borderBottom: "none",
                    borderLeft: "none",
                    borderRight: "none",
                  }}
                />
              ))}
          </div>

          <div className={`${styles.content_list}  border-black-700 `}>
            {["Details",
              "Status",
              "Chat"].map((item) => (
                <span
                  onClick={() => setToggleContent(item)}
                  style={{
                    color:
                      item === toggleContent
                        ? "var(--color--2) "
                        : "var(--light-color3)",
                    cursor: "pointer",
                  }}
                >
                  {item}
                </span>
              ))}
          </div>
          <hr />
          {toggleContent === "Details" && (
            <OrderDetails
              deliveryAddress={orderData?.delivery_address}
              orderDetails={orderData?.orderDetails}
              handleCloseOrderModal={handleCloseOrderModal}
              orderData={orderData}
              onOrderUpdated={refreshOrderList}
            />
          )}
          {toggleContent === "Invoice" && (
            <OrderInvoice invoiceData={orderData} />
          )}
          {toggleContent === "Status" && (
            <OrderStatus orderData={orderData} />
          )}
          {toggleContent === "Chat" && <ChatComponent data={orderData} />}
        </SidebarField>
      </>
    );
  }
};

export default OrderModal;
